(function ($) {
    class GM_ContactForm {
        constructor() {
            this.$form = $('.form');
            if (!this.$form.length) return;

            this.$submitBtn = this.$form.find('button[type="submit"]');
            this.$fields = this.$form.find('input, textarea');

            this.rules = {
                name: {
                    required: true,
                    message: 'Molimo unesite vaše ime i prezime.'
                },
                email: {
                    required: true,
                    pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                    message: 'Molimo unesite ispravnu email adresu.'
                },
                phone: {
                    required: true,
                    pattern: /^[^A-Za-zÀ-ÿĀ-žḀ-ỿ]+$/,
                    message: 'Telefonski broj ne smije sadržavati slova.'
                },
                message: {
                    required: true,
                    minlength: 20,
                    maxlength: 1200,
                    message: 'Poruka mora imati između 20 i 1200 znakova.'
                },
                terms: {
                    required: true,
                    message: 'Morate prihvatiti uvjete korištenja.'
                }
            };

            this.init();
        }

        init() {
            this.$fields.on('blur', (e) => this.handleBlur(e));
            this.$fields.on('input', (e) => this.handleInput(e));
            this.$fields.on('change', (e) => this.handleChange(e));
            this.$form.on('submit', (e) => this.handleSubmit(e));

            this.initWaitTimer();
        }

        initWaitTimer() {
            const $btn = this.$submitBtn;
            if (!$btn.hasClass('btn--waiting')) return;

            setTimeout(() => {
                $btn.prop('disabled', false).removeClass('btn--waiting');
            }, 10000);
        }

        handleBlur(e) {
            const $field = $(e.target);
            if ($field.attr('name') === 'med') return;

            const value = $field.val().trim();
            if (value.length > 0) {
                $field.data('interacted', true);
            }

            if ($field.data('interacted')) {
                this.validateField($field);
            }
        }

        handleInput(e) {
            const $field = $(e.target);
            if ($field.attr('name') === 'med' || $field.is(':checkbox')) return;

            const value = $field.val().trim();
            if (value.length > 0) {
                $field.data('interacted', true);
            }

            if ($field.data('interacted')) {
                this.validateField($field);
            }
        }

        handleChange(e) {
            const $field = $(e.target);
            if ($field.is(':checkbox')) {
                $field.data('interacted', true);
                this.validateField($field);
            }
        }

        validateField($field) {
            const name = $field.attr('name');
            const rule = this.rules[name];
            if (!rule) return true;

            let isValid = true;
            let errorMsg = '';

            const value = $field.is(':checkbox') ? $field.is(':checked') : $field.val().trim();

            if (rule.required && (value === '' || value === false)) {
                isValid = false;
                errorMsg = rule.message;
            } else if (rule.pattern && !rule.pattern.test(value)) {
                isValid = false;
                errorMsg = rule.message;
            } else if (rule.minlength && value.length < rule.minlength) {
                isValid = false;
                errorMsg = rule.message;
            } else if (rule.maxlength && value.length > rule.maxlength) {
                isValid = false;
                errorMsg = rule.message;
            }

            this.toggleError($field, isValid, errorMsg);
            return isValid;
        }

        toggleError($field, isValid, message) {
            const $wrapper = $field.closest('.field');
            const $errorMsg = $wrapper.find('.field__error-msg');

            if (isValid) {
                $field.removeClass('field__input--error');
                $errorMsg.text('');
            } else {
                $field.addClass('field__input--error');
                $errorMsg.text(message);
            }
        }

        handleSubmit(e) {
            e.preventDefault();

            if (this.$submitBtn.prop('disabled')) return;

            let isFormValid = true;
            this.$fields.each((i, el) => {
                const $field = $(el);
                if ($field.attr('name') === 'med') return;

                $field.data('interacted', true);
                if (!this.validateField($field)) {
                    isFormValid = false;
                }
            });

            if (!isFormValid) return;

            // Honeypot check
            if (!window.GM_Helper.checkHoneypot(this.$form)) {
                return;
            }

            const formData = this.$form.serializeArray();
            const data = {};
            formData.forEach(item => {
                data[item.name] = item.value;
            });

            // Loading state
            const iconHtml = this.$submitBtn.find('svg')[0]?.outerHTML || '';
            this.$submitBtn.prop('disabled', true).addClass('is-loading').html(iconHtml);

            $.ajax({
                url: gm_params.ajax_url,
                type: 'POST',
                data: {
                    action: 'gm_contact_form',
                    nonce: gm_params.nonce,
                    ...data
                },
                success: (response) => {
                    if (response.success) {
                        alert('Poruka je uspješno poslana!');
                        this.$form[0].reset();
                        this.resetValidation();
                    } else {
                        alert('Došlo je do pogreške. Molimo pokušajte ponovno.');
                    }
                },
                error: () => {
                    alert('Došlo je do pogreške na poslužitelju.');
                },
                complete: () => {
                    this.$submitBtn.prop('disabled', false).removeClass('is-loading');
                    const iconHtml = this.$submitBtn.find('svg')[0]?.outerHTML || '';
                    const finalBtnText = this.$submitBtn.data('submit-text') || (document.documentElement.lang.startsWith('en') ? 'Send' : 'Pošalji');
                    
                    this.$submitBtn.html(`${iconHtml} ${finalBtnText}`);
                }
            });
        }

        resetValidation() {
            this.$fields.each((i, el) => {
                const $field = $(el);
                $field.data('interacted', false);
                $field.removeClass('field__input--error');
                $field.closest('.field').find('.field__error-msg').text('');
            });
        }
    }

    $(document).ready(() => new GM_ContactForm());
})(jQuery);
